import { connect } from 'react-redux'

import {
  doFetchTrelloCards,
  selectCurrentTicketLinkedCards,
} from 'ducks/integrations/trello'

import TrelloInAppCardView from './view'

const select = state => ({
  cards: selectCurrentTicketLinkedCards(state),
})

const performFactory = {
  doFetchTrelloCards,
}

export default connect(select, performFactory)(TrelloInAppCardView)
